export default __webpack_public_path__ + "static/media/refundlogo.58adb034.png";